import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {getCMSAssets, getCMSGeneral} from "../../utils/cms.utils";

const AboutMain = () => {
    const [general, setGeneral] = useState(null);
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setGeneral(getCMSGeneral());
        setAssets(getCMSAssets());
    }, []);

    if (!general || !assets) return null;

    const descriptions = Array.isArray(general.description)
        ? [...general.description].sort(
            (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
        )
        : [];

    const missionStatements = Array.isArray(general.missionStatement)
        ? [...general.missionStatement].sort(
            (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
        )
        : [];

    return (
        <>
            {/* ================= ABOUT ================= */}
            <section className="about__five section-padding pt-5">
                <div className="container">
                    <div className="row al-center">

                        {/* LEFT */}
                        <div className="col-lg-5 lg-mb-25">
                            <h2 className="about__five-title title_split_anim">
                                Who We Are ?
                            </h2>

                            <div className="about__five-image wow img_left_animation">
                                <img
                                    src={assets.about_us_overview}
                                    alt={general.companyName}
                                />
                            </div>

                            <div className="mission__header text-center">
                                <p className="subtitle">Our Motto</p>
                                <div
                                    className="subtitle-motto"
                                    dangerouslySetInnerHTML={{
                                        __html: general.mottoEn,
                                    }}
                                />
                                <div
                                    className="subtitle-motto"
                                    dangerouslySetInnerHTML={{
                                        __html: general.mottoId,
                                    }}
                                />
                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="col-lg-7">
                            <div className="about__five-right ml-70 xl-ml-0">

                                {/* DESCRIPTION 1 */}
                                {descriptions[0] && (
                                    <>
                                        <div
                                            className="about__five-text wow fadeInUp"
                                            data-wow-delay=".4s"
                                            dangerouslySetInnerHTML={{
                                                __html: descriptions[0].descEn,
                                            }}
                                        />
                                        <div
                                            className="about__five-text sub"
                                            dangerouslySetInnerHTML={{
                                                __html: descriptions[0].descId,
                                            }}
                                        />
                                    </>
                                )}

                                {/* IMAGE CENTER */}
                                {assets.about_us_teams && (
                                    <div
                                        className="about__five-image wow fadeInUp"
                                        data-wow-delay=".5s"
                                    >
                                        <img
                                            src={assets.about_us_teams}
                                            alt="Our Team"
                                        />
                                    </div>
                                )}

                                {/* DESCRIPTION 2 */}
                                {descriptions[1] && (
                                    <>
                                        <div
                                            className="about__five-text"
                                            dangerouslySetInnerHTML={{
                                                __html: descriptions[1].descEn,
                                            }}
                                        />
                                        <div
                                            className="about__five-text sub"
                                            dangerouslySetInnerHTML={{
                                                __html: descriptions[1].descId,
                                            }}
                                        />
                                    </>
                                )}

                                {/* SAFETY / TAGLINE */}
                                <div className="about__five-safety">
                                    <div
                                        className="about__five-text"
                                        dangerouslySetInnerHTML={{
                                            __html: general.taglineEn,
                                        }}
                                    />
                                    <div
                                        className="about__five-text sub"
                                        dangerouslySetInnerHTML={{
                                            __html: general.taglineId,
                                        }}
                                    />
                                </div>

                                {/* SIGNATURE */}
                                <div className="about__five-text signature">
                                    <p>{general.founder}</p>
                                    <span>{general.founderTitle}</span>
                                </div>

                                <div className="item_bounce">
                                    <Link className="build_button mt-20" to="/portfolio">
                                        See Projects
                                        <i className="flaticon-right-up"></i>
                                    </Link>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= VISION / MISSION ================= */}
            <section className="mission__area">
                <div className="container">
                    <section className="vision-mission">
                        <div className="vision-mission__grid">

                            <div className="vision-mission__card">
                                <h2 className="vision-mission__title">Vision</h2>
                                <div
                                    className="vision-mission__text"
                                    dangerouslySetInnerHTML={{
                                        __html: general.visionEn,
                                    }}
                                />
                                <div className="divider"/>
                                <div
                                    className="vision-mission__sub"
                                    dangerouslySetInnerHTML={{
                                        __html: general.visionId,
                                    }}
                                />
                            </div>

                            <div className="vision-mission__card vision-mission__card--mission">
                                <h2 className="vision-mission__title">Mission</h2>
                                <div
                                    className="vision-mission__text"
                                    dangerouslySetInnerHTML={{
                                        __html: general.missionEn,
                                    }}
                                />
                                <div className="divider"/>
                                <div
                                    className="vision-mission__sub"
                                    dangerouslySetInnerHTML={{
                                        __html: general.missionId,
                                    }}
                                />
                            </div>

                        </div>
                    </section>
                </div>
            </section>

            {/* ================= MISSION STATEMENT ================= */}
            {missionStatements.length > 0 && (
                <div className="mission__statement section-padding">
                    <div className="container">

                        <div className="mission__statement-header text-center">
                            <p className="subtitle wow fadeInLeft">Mission Statement</p>
                            <h2 className="title_split_anim">
                                Our Commitment to Excellence
                            </h2>
                            <h5 className="title_split_anim">
                                "Komitmen Kami terhadap Keunggulan"
                            </h5>
                        </div>

                        <div className="row justify-content-center mt-5 mb-2 p-2">
                            <div className="col-lg-10">
                                {missionStatements.map((m, i) => (
                                    <div key={i} className="mission__statement-card">
                                        <i className={`${m?.icon} mission__statement-icon`} />

                                        <div className="mission__statement-content">
                                            <h4 className="mission__statement-title">
                                                {m?.titleEn}
                                            </h4>
                                            <span className="mission__statement-title muted">
            ({m?.titleId})
          </span>
                                        </div>

                                        <div
                                            className="mission__statement-text"
                                            dangerouslySetInnerHTML={{
                                                __html: m?.statementEn || "",
                                            }}
                                        />
                                        <div
                                            className="mission__statement-text sub"
                                            dangerouslySetInnerHTML={{
                                                __html: m?.statementId || "",
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>


                    </div>
                </div>
            )}
        </>
    );
};

export default AboutMain;
